import React, { useState, useEffect } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Select,
  Loader,
  Button,
  Pagination
} from "semantic-ui-react";
import { Container, Content, Center, Text, Header, Sentence } from './styled'
import { pb4y as api, pb4yLocal as local } from "../../../../services/apis";
import { datePattern } from '../../../../utils/Utils';
import { Box } from "@material-ui/core";


const options = [
  { key: 'BR', value: 'BR', text: 'Português' },
  { key: 'EN', value: 'EN', text: 'Inglês' },
  { key: 'ES', value: 'ES', text: 'Espanhol' },
  { key: 'DE', value: 'DE', text: 'Alemão' },
  { key: 'RU', value: 'RU', text: 'Russo' },
  { key: 'ZH', value: 'ZH', text: 'Chinês' },
  { key: 'FR', value: 'FR', text: 'Francês' },
  { key: 'IT', value: 'IT', text: 'Italiano' }
]

function EvaluationDetails(props) {
  const [userRate, setUserRate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { id } = props.match.params;


  useEffect(() => {
    async function getDate() {
      setLoading(true)
      await api.get(`/rate-articles?page=${page}&idArticle=${id}`).then(res => {
        setUserRate(res.data.items)
        setTotalPages(res.data.pages)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        console.error(err);
      })
    }
    getDate()
  }, [page, id])

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
      <AdminMenu />
        <Content>
          <h1>Avaliações do livro</h1>
          <Center space>
            <Pagination
              boundaryRange={0}
              activePage={page}
              defaultActivePage={1}
              onPageChange={(e, f) => setPage(f.activePage)}
              firstItem={null}
              lastItem={null}
              totalPages={totalPages}
            />
          </Center>


          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Id do usuário</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Email</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "30%" }} >
                <Center>Mensagem</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Sentença 1</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Sentença 2</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Sentença 3</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Data</Center>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? <Loader active={loading} /> :
                userRate.length !== 0 ? userRate.map((evaluation) => (
                  <Table.Row>
                    <Table.Cell >
                      <Center>{evaluation.id}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.email}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.number_of_stars}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.message}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.evaluation[0]}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.evaluation[1]}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{evaluation.evaluation[2]}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{datePattern(evaluation.date_sys)}</Center>
                    </Table.Cell>
                  </Table.Row>
                )) : <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan='7'>
                      <Text>Nenhuma avaliação encontrada</Text>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>}
            </Table.Body>
          </Table>
        </Content>
      </Box>
    </Box>
  )
}

export default EvaluationDetails;
